module.exports = __webpack_public_path__ + "img/icon9.61a1fa48.png";